// saga.js
import { all, takeEvery, put } from 'redux-saga/effects';
import profileActions from './actions';
import authActions from '../auth/actions';
import { notification } from '@iso/components';
import { get } from 'jquery';
import { update } from 'lodash';
const gaxios = require('gaxios');

function* fetchProfileDataEffect() {
  try {
    const res = yield gaxios.request({
      url: 'api/users/' + localStorage.getItem('id_token'),
      headers: {
        Authorization: localStorage.getItem('access_token'),
        AuthId: localStorage.getItem('id_token')
      }
    });

    yield put(profileActions.fetchProfileDataSuccess(res.data));
  } catch (error) {
    console.log(error)
    yield put(profileActions.fetchProfileDataFailure(error));
  }
}

function* actualizarPerfil(action) {
  try {
    const res = yield gaxios.request({
      url: 'api/users/' + action.payload._id,
      method: "PUT",
      data: action.payload,
      headers: {
        Authorization: localStorage.getItem('access_token'),
        AuthId: localStorage.getItem('id_token')
      }
    });
    if (res.data.success) {
      notification('success', res.data.msg)
      yield put({
        type: profileActions.SET_PROFILE_DATA,
        profile: res.data.user
      });
      yield put({
        type: authActions.UPDATE_LOGIN_INFO,
        profile: res.data.user
      });

    }
  } catch (error) {
    yield put(profileActions.fetchProfileDataFailure(error));
  }
}

function* getNotificaciones(action) {
  try {
    const res = yield gaxios.request({
      url: 'api/notificaciones/' + localStorage.getItem('id_token'),
      method: "GET",
      headers: {
        Authorization: localStorage.getItem('access_token'),
        AuthId: localStorage.getItem('id_token')
      }
    });
    if (res.data.success) {
      notification('success', res.data.msg);
      yield put({
        type: profileActions.SET_NOTIFICACIONES,
        payload: res.data
      });
    }

  } catch (error) {
    yield put(profileActions.fetchProfileDataFailure(error));
  }
}

function* updateNotificaciones(action) {
  try {
    const res = yield gaxios.request({
      url: 'api/notificaciones/' + localStorage.getItem('id_token'),
      method: "PUT",
      data: action.payload,
      headers: {
        Authorization: localStorage.getItem('access_token'),
        AuthId: localStorage.getItem('id_token')
      }
    });
    if (res.data.success) {
      //notification('success', res.data.msg);
      yield put({
        type: profileActions.SET_NOTIFICACIONES,
        payload: res.data
      });
    }

  } catch (error) {
    yield put(profileActions.fetchProfileDataFailure(error));
  }
}

export default function* profileSaga() {
  yield all([
    takeEvery(profileActions.FETCH_PROFILE_DATA_START, fetchProfileDataEffect),
    takeEvery(profileActions.FETCH_PROFILE_DATA_UPDATE, actualizarPerfil),
    takeEvery(profileActions.GET_NOTIFICACIONES, getNotificaciones),
    takeEvery(profileActions.UPDATE_NOTIFICACIONES, updateNotificaciones),
  ]);
}
